export const masterMenuItems = [
  { label: "Customer", path: "/master/customers" },


  { label: "Warehouse", path: "/master/warehouses" },

  { label: "Zone", path: "/master/zones" },

  { label: "State", path: "/master/states" },
  { label: "Area Code", path: "/master/area-code" },
  { label: "District", path: "/master/districts" },

  { label: "Pincode", path: "/master/pincodes" },
  { label: "Vendor Pincode", path: "/master/vendor-pincodes" },
  { label: "Location", path: "/master/locations" },
  // { label: "Branch", path: "/master/branches" },

  // { label: "Hub", path: "/master/hubs" },


  { label: "Mode", path: "/master/modes" },

  { label: "TAT", path: "/master/tat" },
  { label: "Content", path: "/master/content" },
  { label: "Package", path: "/master/packageTypes" },
  // { label: "Department", path: "/master/departments" },
  // { label: "User", path: "/master/users" },

  // { label: "Rates", path: "/master/rates" },
  // { label: "Vehicles", path: "/master/vehicles" },
  // { label: "Bank", path: "/master/banks" },
  // { label: "Role", path: "/master/roles" },

  // { label: "Drivers", path: "/master/drivers" },

  { label: "Vendor", path: "/master/vendors" },
  { label: "TA", path: "/master/ta" },
];